<dynamic-form-v2 
    *ngIf="!isLoading" 
    entityType="schedule-types" 
    [formName]="title" 
    [record]="scheduleTypeRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
>
</dynamic-form-v2>